import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger, DialogClose } from "@/components/ui/dialog";
import { HelpCircle, X } from "lucide-react";
import { Button } from "./ui/button";
import { labelPluralLower } from "@/utils/copyTituloBilhete";

export default function CompraRapidaOqueE() {
    return <Dialog>
        <DialogTrigger asChild>
            <button
                type="button"
                className="inline-flex items-center justify-center rounded-full p-1.5 text-primary hover:text-primary/80 hover:bg-primary/5 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                aria-label="O que é Compra Rápida?"
            >
                <HelpCircle className="w-5 h-5" />
            </button>
        </DialogTrigger>
        <DialogContent>
            <DialogHeader className="flex flex-row items-start justify-between space-y-0">
                <div className="space-y-2">
                    <DialogTitle>O que é Compra Rápida?</DialogTitle>
                    <DialogDescription>
                        A <span className="font-semibold">Compra Rápida</span> é a maneira mais simples de adquirir seus {labelPluralLower()}. Basta escolher a quantidade desejada, informar seu CPF e finalizar o pagamento via PIX.
                        <br />
                        <br />
                        Após o pagamento aprovado, seus {labelPluralLower()} são vinculados ao seu CPF, e você pode consultá-los sempre que quiser acessando a área de histórico de compras.
                    </DialogDescription>
                </div>
                <DialogClose asChild>
                    <button
                        type="button"
                        className="ml-4 rounded-full p-1 text-muted-foreground hover:text-foreground hover:bg-muted focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                        aria-label="Fechar"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </DialogClose>
            </DialogHeader>
            <DialogFooter>
                <DialogClose asChild>
                    <Button type="button">
                        Entendi
                    </Button>
                </DialogClose>
            </DialogFooter>
        </DialogContent>
    </Dialog>
}